import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import { isValidToken, getTokenData } from '../../utils';
import { utf8ToBase64 } from '@hobs/utils/base64Utils/base64Utils';

const PrivateRoute = ({
  redirect = '/logout',
  component: Component,
  layout: Layout,
  layoutProps,
  ...rest
}) => {
  const getRedirectPath = oldLocation => {
    const encodedRedirectPath = utf8ToBase64(oldLocation.pathname);
    return redirect + `/${encodedRedirectPath}`;
  };

  return (
    <Route
      {...rest}
      render={props => {
        const token = localStorage.getItem('token');
        if (token && isValidToken(token)) {
          if (
            getTokenData(token).AgreedToExercise === 'False' &&
            props.location.pathname !== '/terms-and-conditions'
          ) {
            return (
              <Redirect
                to={{
                  pathname: '/terms-and-conditions',
                  state: { from: props.location }
                }}
              />
            );
          }
          if (
            getTokenData(token).IsInfoUpdateRequired === 'True' &&
            props.location.pathname !== '/update-info' &&
            (getTokenData(token).AgreedToExercise === 'True' ||
              getTokenData(token).AgreedToExercise === undefined)
          ) {
            return (
              <Redirect
                to={{
                  pathname: '/update-info',
                  state: { from: props.location }
                }}
              />
            );
          }

          if (Layout) {
            return (
              <Layout {...layoutProps}>
                <Component {...props} />
              </Layout>
            );
          }

          return <Component {...props} />;
        }

        return (
          <Redirect
            to={{
              pathname: getRedirectPath(props.location),
              state: { from: props.location }
            }}
          />
        );
      }}
    />
  );
};

PrivateRoute.propTypes = {
  redirect: PropTypes.string,
  component: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.element,
    PropTypes.object
  ]),
  layout: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.element,
    PropTypes.object
  ]),
  layoutProps: PropTypes.object,
  location: PropTypes.object
};

export default PrivateRoute;
